// extracted by mini-css-extract-plugin
module.exports = {"slick-slider":"lSaBM","slick-Image":"WFRxJ","arrow-right":"_30o1Z","arrow-left":"P7LyY","event-card-container":"_3Jomw","shake":"_1Rhps"};